export const MQ = (query) => {
	const { breakpointsVars = {}, rules = {} } = PROJECT_CONFIG;
	// Support shorthand like "lgUp" / "xlDown" based on configured breakpoints.
	// This project stores raw breakpoint values (e.g. "62.5rem") under keys like "lg".
	const shorthandMatch = typeof query === 'string' ? query.match(/^([a-z0-9]+)(Up|Down)$/i) : null;
	if (shorthandMatch) {
		const [, bpKeyRaw, dir] = shorthandMatch;
		const bpKey = bpKeyRaw.toLowerCase();
		const bpValue = breakpointsVars[bpKey];
		if (bpValue != null) {
			const mediaQuery = dir === 'Up' ? `(width >= ${bpValue})` : `(width < ${bpValue})`;
			return window.matchMedia(mediaQuery).matches;
		}
	}
	if (breakpointsVars[query] != null) return window.matchMedia(`(${breakpointsVars[query]})`).matches;
	if (rules[query] != null) return window.matchMedia(rules[query]).matches;
	return window.matchMedia(query).matches;
};

export const media = MQ;
